import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 讀取序號登錄與檢測履歷。serialNumber 不做 trim。 */
export async function fetchMaterialSn(serialNumber) {
  const { data: raw } = await request.get(
    `/ims/material-sns/${encodeURIComponent(serialNumber)}`,
  );
  return parseVer4DetailResponse(raw);
}
